














import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class FiltroEnum extends Vue {
  @Prop() public readonly data!: IFiltroField;
  public filtroSelecionado = '';

  get opcoes(): IFiltroEnum[] {
    return this.data.enum as IFiltroEnum[];
  }

  input(value: string): void {
    const filtro: IFiltroValues = {
      field: this.data.id,
      operator: 'eq',
      value: value,
    };
    this.$emit('input', filtro);
  }
}
